import { render } from "./ApprovePassword.vue?vue&type=template&id=f403ff6e&scoped=true"
import script from "./ApprovePassword.vue?vue&type=script&lang=js"
export * from "./ApprovePassword.vue?vue&type=script&lang=js"

import "./ApprovePassword.vue?vue&type=style&index=0&id=f403ff6e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f403ff6e"]])

export default __exports__